export default {
  data() {
    return {
      error: {
        show: false,
        message: '',
        description: '',
      },
    };
  },

  methods: {
    showError(error) {
      this.error.show = true;

      let errorMessage;
      if (error.response && error.response.data) {
        errorMessage = error.response.data.error.message;
      } else {
        errorMessage = error.message;
      }

      this.error.message = errorMessage;
      this.error.description = error.description;
    },

    hideError() {
      this.error.show = false;
      this.error.message = '';
      this.error.description = '';
    },
  },
};
